import { ProductCardTag } from './ProductCardTag'

export default ProductCardTag
